// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-F":"F_GS_outdoor-recreation-F__uVwM4"};